import { DashboardContextProvider } from "../../context/dashboardContext"
import EmptyState from "@common/emptyState"

// This one is used for create data source, create topics to provide dashboard context
export const EmptyResearchLayout = ({ children }) => (
  <DashboardContextProvider>
    <div className="flex justify-center md:hidden w-screen h-screen">
      <EmptyState
        title="Please switch to a laptop/desktop."
        subTitle="Mobile view coming soon!"
      />
    </div>
    <div className="hidden md:block">{children}</div>
  </DashboardContextProvider>
)

export const getLayout = (page) => <EmptyResearchLayout>{page}</EmptyResearchLayout>
